import { createContext } from "react";

const CoachContext = createContext();

export default CoachContext;
